import { Dialog } from "construct-ui";
import ViewBase from "../../../view-base.view";
import FileUploadInputComponent from "../../../../components/file/file-upload-input.component";
import { FILE_EXTENSIONS } from "../../../../config/constants";
import IMEIExtendedWarrantyModel from "../../../../models/imei-extended-warranty/imei-extended-warranty.model";

/**
 * IMEI Extended Warranty - Excel Upload Dialog
 * 
 * The upload dialog used to download excel template and upload records for CRUD
 * 
 * @author cmcnkhiep
 */

export default function IMEIExtendedWarrantyUploadDialog() {
  ViewBase.call(this);

  const FORM_ID = 'IMEIExtendedWarrantygExcelUploadForm';
  const UPLOAD_INPUT_ID = 'IMEIExtendedWarrantygExcelUploadInput';

  let file = null;
  let handleCloseDialog = (isReloadTable) => { }

  const downloadIMEIExtendedWarrantyExcelTemplate = () => {
    this.showLoading();
    IMEIExtendedWarrantyModel.downloadIMEIExtendedWarrantyExcelTemplate()
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const upload = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    this.showLoading();
    IMEIExtendedWarrantyModel.uploadExcelIMEIExtendedWarranty(file)
      .then((result) => {
        this.showMessage(this.getText('EM00000313', 'Upload Completed'), this.getText('EM00000004', 'Success'), () => { handleCloseDialog(true) })
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  return {
    view: ({ attrs: { isOpen, onClose } }) => {
      handleCloseDialog = onClose;
      return m(Dialog,
        {
          isOpen,
          onClose,
          class: 'cui-dialog-lg',
          title: this.getText('LT00001105', 'Upload IMEI Extended Warranty'),
          content: m('container',
            m('ol',
              m('li.fw-bold.mb-4',
                m('.mb-2', this.getText('LT00000018', 'Excel Download')),
                m('button.btn.btn-primary',
                  {
                    onclick: downloadIMEIExtendedWarrantyExcelTemplate
                  },
                  m('i.bi.bi-file-earmark-arrow-down-fill'),
                  this.getText('LT00000218', 'Download Template')
                ),
              ),
              m('hr'),
              m('li.fw-bold.mb-4',
                m('.mb-2', this.getText('LT00000197', 'Excel Upload')),
                m('form.position-relative.needs-validation[novalidate]', { id: FORM_ID, onsubmit: upload },
                  m(FileUploadInputComponent, {
                    id: UPLOAD_INPUT_ID,
                    accept: FILE_EXTENSIONS.XLSX,
                    required: true,
                    onInput: (data) => { file = data; },
                  }),
                )
              )
            ),
            this.getBaseViews()
          ),
          footer: m('.d-flex.gap-2.justify-content-end',
            m('button.btn.btn-primary', { type: 'submit', form: FORM_ID, disabled: !!!file }, this.getText("LT00000290", "Upload")),
            m('button.btn.btn-white', { onclick: onClose }, this.getText("LT00000021", "Close"))
          )
        }
      );
    }
  }
}
